"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saleTypeOption = exports.saleRecordOption = exports.refundMsgOption = exports.examintBaseOption = exports.createSaleOption = exports.compensationTypeOption = exports.changeMsgOption = void 0;
var examintBaseOption = exports.examintBaseOption = [
// 售后审核-订单基础信息
{
  title: '订单编号',
  dataIndex: 'orderNo'
}, {
  title: '订单状态',
  dataIndex: 'statusName'
}, {
  title: '收货人',
  dataIndex: 'receiverNameStr'
},
// 收货人+收货电话
{
  title: '收货地址',
  dataIndex: 'receiverAddress'
}, {
  title: '商品总价',
  dataIndex: 'totalPrice'
}, {
  title: '订单总价',
  dataIndex: 'orderTotalPrice'
}, {
  title: '优惠',
  dataIndex: 'discount',
  isWarning: true
}, {
  title: '卡券',
  dataIndex: 'couponPrice',
  isWarning: true
}, {
  title: '实付',
  dataIndex: 'paidPrice'
}, {
  title: '福豆',
  dataIndex: 'useIntegral',
  isWarning: true
}, {
  title: '支付方式',
  dataIndex: 'payTypeName'
}, {
  title: '下单时间',
  dataIndex: 'createTime'
}, {
  title: '付款时间',
  dataIndex: 'payTime'
}, {
  title: '发货时间',
  dataIndex: 'shipmentsTime'
}, {
  title: '物流信息',
  dataIndex: 'transportStr',
  widthAll: true
}, {
  title: '售后类型',
  dataIndex: 'aftersaleTypeDesc',
  isAftersale: true
}, {
  title: '售后状态',
  dataIndex: 'statusDesc',
  isAftersale: true
}];
var createSaleOption = exports.createSaleOption = [
// 创建售后-订单基础信息
{
  title: '订单编号',
  dataIndex: 'orderNo'
}, {
  title: '订单状态',
  dataIndex: 'statusName'
}, {
  title: '收货人',
  dataIndex: 'receiverNameStr'
},
// 收货人+收货电话
{
  title: '收货地址',
  dataIndex: 'receiverAddress'
}, {
  title: '商品总价',
  dataIndex: 'totalPrice'
}, {
  title: '订单总价',
  dataIndex: 'orderTotalPrice'
}, {
  title: '运费',
  dataIndex: 'freight'
}, {
  title: '实付',
  dataIndex: 'paidPrice'
}, {
  title: '福豆',
  dataIndex: 'useIntegral',
  isWarning: true
}, {
  title: '优惠',
  dataIndex: 'discount',
  isWarning: true
}, {
  title: '卡券',
  dataIndex: 'couponPrice',
  isWarning: true
}, {
  title: '支付方式',
  dataIndex: 'payTypeName'
}, {
  title: '下单时间',
  dataIndex: 'createTime'
}, {
  title: '付款时间',
  dataIndex: 'payTime'
}, {
  title: '发货时间',
  dataIndex: 'shipmentsTime'
}, {
  title: '签收时间',
  dataIndex: 'receiveTime'
}, {
  title: '完结时间',
  dataIndex: 'endTime'
}, {
  title: '物流信息',
  dataIndex: 'transportStr',
  widthAll: true
}];
var saleRecordOption = exports.saleRecordOption = [
// 售后明细-订单基础信息
{
  title: '订单编号',
  dataIndex: 'orderNo'
}, {
  title: '订单状态',
  dataIndex: 'statusName'
}, {
  title: '收货人',
  dataIndex: 'receiverNameStr'
},
// 收货人+收货电话
{
  title: '收货地址',
  dataIndex: 'receiverAddress'
}, {
  title: '商品总价',
  dataIndex: 'totalPrice'
}, {
  title: '订单总价',
  dataIndex: 'orderTotalPrice'
}, {
  title: '优惠',
  dataIndex: 'discount',
  isWarning: true
}, {
  title: '卡券',
  dataIndex: 'couponPrice',
  isWarning: true
}, {
  title: '实付',
  dataIndex: 'paidPrice'
}, {
  title: '福豆',
  dataIndex: 'useIntegral',
  isWarning: true
}, {
  title: '支付方式',
  dataIndex: 'payTypeName'
}, {
  title: '下单时间',
  dataIndex: 'createTime'
}, {
  title: '付款时间',
  dataIndex: 'payTime'
}, {
  title: '发货时间',
  dataIndex: 'shipmentsTime'
}, {
  title: '物流信息',
  dataIndex: 'transportStr',
  widthAll: true
}, {
  title: '售后类型',
  dataIndex: 'aftersaleTypeDesc',
  isAftersale: true,
  isWarning: true
}, {
  title: '售后状态',
  dataIndex: 'statusDesc',
  isAftersale: true,
  isWarning: true,
  widthAll: true
}, {
  title: '退款信息',
  dataIndex: 'refundStr',
  isWarning: true,
  isAftersale: true,
  widthAll: true
},
// 特殊处理：展示 现金、积分
{
  title: '审核备注',
  dataIndex: 'adminReason',
  isAftersale: true,
  widthAll: true
}];
var saleTypeOption = exports.saleTypeOption = [
// 售后类型
{
  name: '退货退款',
  value: 1
}, {
  name: '仅退款',
  value: 2
}, {
  name: '换货',
  value: 3
}, {
  name: '赔付',
  value: 4
}];
var refundMsgOption = exports.refundMsgOption = [
// 退货信息-售后明细用
{
  title: '收件人',
  dataIndex: 'realName'
}, {
  title: '收件电话',
  dataIndex: 'phone'
}, {
  title: '收件地址',
  dataIndex: 'detail'
}];
var changeMsgOption = exports.changeMsgOption = [
// 换货信息-售后明细用
{
  title: '收件人',
  dataIndex: 'realName'
}, {
  title: '收件电话',
  dataIndex: 'phone'
}, {
  title: '收件地址',
  dataIndex: 'detail'
}];

// 赔付类型选项
var compensationTypeOption = exports.compensationTypeOption = [{
  value: 1,
  label: '商品损坏赔付'
}, {
  value: 2,
  label: '延迟发货赔付'
}, {
  value: 3,
  label: '质量问题赔付'
}, {
  value: 4,
  label: '服务问题赔付'
}, {
  value: 5,
  label: '其他赔付'
}];